import { render, staticRenderFns } from "./FilterGlossaryBadObjects.vue?vue&type=template&id=5bc76a1a&scoped=true&"
import script from "./FilterGlossaryBadObjects.vue?vue&type=script&lang=js&"
export * from "./FilterGlossaryBadObjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc76a1a",
  null
  
)

export default component.exports